import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';

import { resetDataApp } from '../../entities/auth/lib';
import { storageKeys } from '../config';

const enrichedBaseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL}/DataService.svc/v1/`,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem(storageKeys.token);

    if (token) {
      headers.set('X-Api-Token', token);
    }

    return headers;
  },
});

export const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const result = await enrichedBaseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    resetDataApp();
  }

  return result;
};

export const rootApi = createApi({
  reducerPath: 'root',
  baseQuery,
  endpoints: () => ({}),
});
